export default import.meta.ROLLUP_FILE_URL_7m8RfB8zReHk1VozjdmCsA